import { Descriptions, Divider, Drawer } from "antd";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { cashConverter } from "../../../utils";

function RiverTrainingView({ onClose, open, prodd }) {
  const navigate = useNavigate();

  const items1 = [
    {
      key: "1",
      label: "Project Name",
      children: prodd?.riverName ?? "N/A",
    },
    
    {
      key: "2",
      label: "Length of River Drained",
      children: prodd?.riverTrainedLength ?? "N/A",
    },
    {
      key: "3",
      label: "Height",
      children: prodd?.riverHeight ?? "N/A",
    },
    {
      key: "4",
      label: "No of Gabions Used",
      children: prodd?.riverGabionsNo ?? "N/A",
    },
    {
      key: "5",
      label: "Acreage Protected",
      children: prodd?.riverAcreageProtected ?? "N/A",
    },
    {
      key: "13",
      label: "Acreage Farmed",
      children: prodd?.riverAcreageFarmed ?? "N/A",
    },
    {
      key: "6",
      label: "Start Date",
      children: (
        <div>
          {prodd?.riverStartDate
            ? moment(prodd?.riverStartDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
    {
      key: "7",
      label: "End Date",
      children: (
        <div>
          {prodd?.riverEndDate
            ? moment(prodd?.riverEndDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
    {
      key: "8",
      label: "Budget/Cost",
      children: prodd?.riverCost ?? "N/A",
    },
   
    {
      key: "9",
      label: "Remarks",
      children: prodd?.riverRemarks ?? "N/A",
    },
  ];
  const items2 = [
    {
      key: "5",
      label: "County",
      children: prodd?.countyCode ?? "N/A",
    },
    {
      key: "1",
      label: "SubCounty",
      children: prodd?.subCountyCode ?? "N/A",
    },
    {
      key: "2",
      label: "Location",
      children: prodd?.locLocation ?? "N/A",
    },
    {
      key: "3",
      label: "SubLocation",
      children: prodd?.slocLocation ?? "N/A",
    },
    {
      key: "45",
      label: "Constituency",
      children: prodd?.constName ?? "N/A",
    },
    {
      key: "4",
      label: "Ward",
      children: prodd?.wdWard ?? "N/A",
    }, 
    {
      key: "2",
      label: "Cost",
      children: <div>{cashConverter(prodd?.riverCost)}</div>,
    },
    
    {
      key: "8",
      label: "Funding Source",
      children: prodd?.riverSourceFunds ?? "N/A",
    },
    {
      key: "8",
      label: "Crops",
      children: prodd?.riverCrops ?? "N/A",
    }, 
    
    {
      key: "11",
      label: "Estimated Beneficiaries",
      children: prodd?.riverEstBeneficiaries ?? "N/A",
    },
    {
      key: "12",
      label: "Pathways",
      children: prodd?.riverPathways ?? "N/A",
    },
    {
      key: "12",
      label: "Implementing Agency",
      children: prodd?.riverAgency ?? "N/A",
    },
    {
      key: "13",
      label: "Managing Entity",
      children: prodd?.riverManagingAgency ?? "N/A",
    },
    
  ];
 
  return (
    <Drawer width={800} title="Basic Drawer" open={open} onClose={onClose}>
      <div className="flex justify-between items-center">
        <div className="details_h">River Training Infomation</div>
      </div>

      <div className="mt-[1rem]">
        <Divider />
      </div>
      <div className="w-full mt-[2.75rem] flex">
        <Descriptions
          title=""
          column={1}
          colon={false}
          items={items1}
          layout="vertical"
        />
        <Descriptions
          title=""
          column={1}
          colon={false}
          items={items2}
          layout="vertical"
        />
        
      </div>
    </Drawer>
  );
}

export default RiverTrainingView;
